"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author arsen.avagumyan on 1/15/2018.
 */
var Category = /** @class */ (function () {
    function Category(dbId, type, id, name) {
        this.dbId = dbId;
        this.type = type;
        this.id = id;
        this.name = name;
    }
    return Category;
}());
exports.Category = Category;
var CategoryCache = /** @class */ (function () {
    function CategoryCache() {
    }
    CategoryCache.newCategory = function (dbId, type, id, name) {
        for (var _i = 0, _a = this.cache; _i < _a.length; _i++) {
            var categoryByCache = _a[_i];
            if (categoryByCache.type == type && categoryByCache.id == type && categoryByCache.id == type) {
                if (!categoryByCache.dbId && dbId) { //TODO Arsen dbId and name
                    categoryByCache.dbId = dbId;
                }
                if (!categoryByCache.name && name) {
                    categoryByCache.name = name;
                }
                return categoryByCache;
            }
        }
        var category = new Category(dbId, type, id, name);
        this.cache.push(category);
        return category;
    };
    CategoryCache.cache = [];
    return CategoryCache;
}());
exports.CategoryCache = CategoryCache;
//# sourceMappingURL=category.model.js.map